module.exports = __webpack_public_path__ + "static/img/reuter_header_logo.7b0108a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reuter_header_logo.jpg
// module id = yvke
// module chunks = 12